import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Divider,
  Select,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import { Add, Delete, CopyAll, Settings } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import {
  countryData,
  vendorsData as customerData,
  itemData,
  // vendorsData,
} from "../../../lib/data";
import { Checkbox, ListItemText, FormControl, InputLabel } from "@mui/material";
import ApiPath from "../../../utils/api";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs"; // For date formatting
import { useDataContext } from "../../../context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import axios from "axios";

const InvoiceInterface = () => {
  // const { itemList: initialRows } = useDataContext();
  const [customer, setCustomer] = useState(null); // State to store selected customer
  const [items, setItems] = useState([]); // State to store selected items
  const location = useLocation();
  const [formErrors, setFormErrors] = useState({});
  // const { selectedRows } = location.state;
  const selectedRows = location.state?.selectedRows || [
    {
      name: "",
      passport: "",
      nationality: "",
      lastname: "",
      firstname: "",
      price: 0,
      quantity: 1,
    },
  ];
  const [invoiceDetails, setInvoiceDetails] = useState({
    salesperson: "",
    note: "",
    paymentMode: "",
  });
  const {
    bankTransferData,
    PaymentMode,
    vendors: vendorsData,
    itemList,
    userList,
    getBankTransfer,
    fetchAllData,
  } = useDataContext();
  const [invoiceNumber, setInvoiceNumber] = useState(""); // State for invoice number
  const [issuedDate, setIssuedDate] = useState(""); // State for issued date
  const [dueDate, setDueDate] = useState(""); // State for due date
  const [selectedModes, setSelectedModes] = useState([]); // State to store selected payment modes
  const [amounts, setAmounts] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({}); // State
  const navigate = useNavigate();
  // Available payment modes
  const [file, setFile] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);
  const [loadingImage, setloadingImage] = useState(false);

  const handleFileChange = async (event) => {
    setloadingImage(true);
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    // Prepare the file for upload
    const formData = new FormData();
    formData.append("image", selectedFile);
    try {
      // Upload the image and wait for the response
      const response = await axios.post(
        "https://admin.tidyhub.ae/uploadsystem.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true, // Required for CORS with credentials
        }
      );
      // Extract the image URL from the response
      const imageUrl = response.data.filePath; // Match the response structure from PHP
      // Update the state with the image URL
      setUploadedFile(imageUrl);
      console.log("imageUrl", imageUrl);
      // alert("File uploaded successfully");
    } catch (error) {
      console.error("Error uploading file: ", error);
    } finally {
      // Reset the loading state
      // setloadingImage(null);
    }
    setloadingImage(false);
  };

  // Available payment modes
  // const paymentModes = ["Bank", "Mobile Money", "Cash"];
  const paymentModes = PaymentMode;
  // const [customerData, setCustData] = useState(""); // State for due date
  // const [customerData, setCustData] = useState([]); // Initialize as an empty array
  const validateForm = () => {
    const errors = {};
    items.forEach((item, index) => {
      if (!item.firstname) {
        errors[`firstname_${index}`] = "Required";
      }

      if (!item.lastname) {
        errors[`lastname_${index}`] = "Required";
      }
      if (!item.passport) {
        errors[`passport_${index}`] = "Required";
      }
      if (!item.nationality) {
        errors[`nationality_${index}`] = "Required";
      }
      if (!item.price || item.price <= 0) {
        errors[`price_${index}`] = "Required";
      }
    });
    if (!customer) {
      errors[`customer`] = "Required";
    }
    selectedModes.forEach((mode) => {
      if (!selectedOptions[mode]) {
        errors[mode] = "Option is required";
      }
      if (!amounts[mode]) {
        errors[`${mode}_amount`] = "Amount is required";
      }
    });
    return errors;
  };
  useEffect(() => {
    if (selectedRows) {
      setItems(selectedRows);
      console.log(selectedRows);
    }
    const randomInvoiceNumber = Math.floor(100000 + Math.random() * 900000); // Random 6-digit number
    setInvoiceNumber(randomInvoiceNumber);
    const currentDate = new Date(); // Current date
    const formattedIssuedDate = currentDate.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY
    const due = new Date(currentDate);
    due.setDate(currentDate.getDate() + 7); // Set due date 7 days from today
    const formattedDueDate = due.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY

    console.log("selectedRows", selectedRows);
    setIssuedDate(formattedIssuedDate);
    setDueDate(formattedDueDate);
  }, []);

  // Function to compute subtotal, tax, and total dynamically
  const calculateInvoiceTotals = () => {
    const subtotal = items.reduce((acc, item) => acc + item.price * 1, 0);
    const tax = 0; // Example: 5% tax rate
    const total = subtotal + tax;
    return { subtotal, tax, total };
  };
  const { subtotal, tax, total } = calculateInvoiceTotals();
  // Handle form submission
  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    const combined = [];
    // Iterate through the selectedOptions object
    for (const [mode, account] of Object.entries(selectedOptions)) {
      // Check if the mode exists in the amounts object
      if (amounts.hasOwnProperty(mode)) {
        // Add the mode, account name, and amount to the combined array
        combined.push({
          mode: mode.toLowerCase(),
          account: account?._id ? account._id : "", // Access the name property and convert to lowercase
          amount: amounts[mode], // Get the corresponding amount
        });
      }
    }
    const invoiceData = {
      invoiceNumber,
      issuedDate,
      dueDate,
      customer: {
        name: customer.firstName + " " + customer.lastName,
        email: customer.email,
        mobile: customer.mobileCode + customer.mobileNumber,
      },
      items,
      subtotal,
      discount: 0,
      tax,
      total,
      salesperson: "purchased",
      note: invoiceDetails.note,
      paymentMode: combined,
      file: UploadedFile,
    };
    // console.log("...", invoiceData);
    try {
      const response = await ApiPath.post("/purchase", invoiceData);
      message.success("Purchase submitted successfully!");
      fetchAllData();
      setTimeout(() => {
        // const navigate = useNavigate();
        navigate(`/purchase/view/${response.data._id}`);
      }, 1000);
    } catch (error) {
      console.error("Error submitting invoice:", error);
      message.error("Failed to submit invoice.");
    }
  };

  const handleCustomerChange = (event, value) => {
    setCustomer(value); // Update selected customer
    // console.log(value);
  };

  // Function to add a new item to the invoice
  const handleAddItem = () => {
    setItems([
      ...items,
      {
        name: "",
        passport: "",
        nationality: "",
        lastname: "",
        firstname: "",
        price: 0,
        quantity: 1,
      },
    ]); // Example: Add a new item dynamically
  };

  // Function to delete an item from the invoice
  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems); // Update the items array by removing the selected item
  };

  const handleCloneItem = (index) => {
    const clonedItem = { ...items[index] }; // Create a copy of the item
    const updatedItems = [...items, clonedItem]; // Add the cloned item to the array
    setItems(updatedItems); // Update the items array with the new cloned item
  };

  const handleItemChange = (index, newQuantity) => {
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      name: newQuantity.ItemCategory + " | " + newQuantity.ItemDescription, // Update nationality
    };
    setItems(newItems); // Update the state with the new items array
  };

  const handleItemPriceChange = (index, newQuantity) => {
    const updatedItems = [...items];
    updatedItems[index].price = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };
  const handleFirstNamePriceChange = (index, newQuantity) => {
    const updatedItems = [...items];
    updatedItems[index].firstname = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };
  const handleLastNamePriceChange = (index, newQuantity) => {
    const updatedItems = [...items];
    updatedItems[index].lastname = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };
  const handlePassportNamePriceChange = (index, newQuantity) => {
    const updatedItems = [...items];
    updatedItems[index].passport = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };

  const handleNationalityChange = (index, selectedOption) => {
    // Assume `selectedOption` is the country object with a `name` and `price`
    const newItems = [...items];

    // Update the item at the given index
    newItems[index] = {
      ...newItems[index],
      nationality: selectedOption.name, // Update nationality
    };

    setItems(newItems); // Update the state with the new items array
  };

  // Handle the selection change
  // const handleChange = (event) => {
  //   setSelectedModes(event.target.value);
  // };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // Convert to an array for easier handling
    const selected = typeof value === "string" ? value.split(",") : value;

    // Identify the modes being deselected
    const deselectedModes = selectedModes.filter(
      (mode) => !selected.includes(mode)
    );
    // Update the selected modes
    setSelectedModes(selected);
    // Remove amounts for deselected modes
    deselectedModes.forEach((mode) => {
      setAmounts((prevAmounts) => {
        const newAmounts = { ...prevAmounts };
        delete newAmounts[mode]; // Delete the object property for deselected mode
        return newAmounts;
      });
    });
  };

  const handleAmountChange = (mode, value) => {
    setAmounts((prev) => ({ ...prev, [mode]: value })); // Update the amount for the specified mode
  };

  // const handleOptionChange = (mode, value) => {
  //   // console.log("value", value)
  //   setSelectedOptions((prev) => ({ ...prev, [mode]: value })); // Update the selected option for the specified mode
  // };

  const handleOptionChange = (mode, value, name) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [mode]: { _id: value, name: name }, // Store both the _id and name under the mode key
    }));
  };

  return (
    <Box
      style={{
        padding: 20,
      }}
    >
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Invoice Section */}
          <Grid item xs={12} lg={9}>
            <Card sx={{ p: 3, background: "#fffcfc" }}>
              <Box p={3} borderRadius={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={9}>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box color="primary.main">
                        <img
                          src="https://bestoptiontravels.com/static/media/bestsv.e337dc0f8c932b77b8eef6b0d72b2442.svg"
                          height="70"
                          alt="Logo"
                        />
                      </Box>
                    </Box>
                    <Typography variant="body1">
                      Al Yasat tower, Office No 603, 6th floor,
                    </Typography>
                    <Typography variant="body1">
                      Najda Street, Abu dhabi
                    </Typography>
                    <Typography variant="body1">
                      +971 2 448 941 | +971 54 410 9635
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">Purchases :</Typography>
                        <TextField
                          fullWidth
                          size="small"
                          value={invoiceNumber}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                #
                              </InputAdornment>
                            ),
                          }}
                          disabled // Disable input since it's auto-generated
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          Date Issued:
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          value={issuedDate} // Set issued date from state
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">Due Date:</Typography>
                        <TextField
                          fullWidth
                          size="small"
                          value={dueDate} // Set due date from state
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={vendorsData}
                      getOptionLabel={(option) =>
                        `${option.firstName}  ${option.lastName}`
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendor Name"
                          size="small"
                          placeholder="Vendor Name"
                          fullWidth
                          error={!!formErrors[`customer`]}
                          helperText={formErrors[`customer`]}
                        />
                      )}
                      onChange={handleCustomerChange} // Update selected customer
                      isOptionEqualToValue={(option, value) =>
                        option.ItemName === value.ItemName
                      }
                    />
                    <br />
                    <Typography>
                      {customer?.FirstName} {customer?.LastName}
                    </Typography>
                    <Typography>{customer?.Email}</Typography>
                    <Typography>{customer?.Mobile}</Typography>
                  </Grid>
                </Grid>
                <Divider sx={{ my: 3 }} />
                <form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={0.3}>
                      <Typography variant="subtitle1">#</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography variant="subtitle1">Item</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography variant="subtitle1">First Name</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography variant="subtitle1">Last Name</Typography>
                    </Grid>
                    <Grid item xs={12} md={1.5}>
                      <Typography variant="subtitle1">Passport No.</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography variant="subtitle1">Nationality</Typography>
                    </Grid>
                    <Grid item xs={12} md={1}>
                      <Typography variant="subtitle1">Price</Typography>
                    </Grid>
                    <Grid item xs={12} md={1}></Grid>
                  </Grid>
                  <br />
                  {items.map((item, index) => (
                    <Box mb={3} key={index}>
                      <Box display="flex" borderRadius={2}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={0.3}>
                            {index + 1}
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Autocomplete
                              options={itemList}
                              getOptionLabel={(option) => `${option.ItemData}`}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Item"
                                  size="small"
                                  placeholder="Select Item"
                                  fullWidth
                                />
                              )}
                              onChange={(e, data) =>
                                handleItemChange(index, data)
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.ItemData === value.ItemData
                              }
                              value={itemList.find(
                                (country) => country.ItemData === item.name
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              type="text"
                              value={item.firstname}
                              onChange={(e) =>
                                handleFirstNamePriceChange(
                                  index,
                                  e.target.value
                                )
                              } // Handle price change
                              size="small"
                              placeholder="First Name"
                              fullWidth
                              error={!!formErrors[`firstname_${index}`]}
                              helperText={formErrors[`firstname_${index}`]}
                              required
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              type="text"
                              value={item.lastname}
                              onChange={(e) =>
                                handleLastNamePriceChange(index, e.target.value)
                              } // Handle price change
                              size="small"
                              placeholder="Last Name"
                              error={!!formErrors[`lastname_${index}`]}
                              helperText={formErrors[`lastname_${index}`]}
                              fullWidth
                              required
                            />
                          </Grid>
                          <Grid item xs={12} md={1.5}>
                            <TextField
                              type="text"
                              value={item.passport}
                              onChange={(e) =>
                                handlePassportNamePriceChange(
                                  index,
                                  e.target.value
                                )
                              } // Handle price change
                              size="small"
                              placeholder="Passport No."
                              error={!!formErrors[`passport_${index}`]}
                              helperText={formErrors[`passport_${index}`]}
                              fullWidth
                              required
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Autocomplete
                              options={countryData}
                              getOptionLabel={(option) => `${option.name}`}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Nationality"
                                  size="small"
                                  placeholder="Select Nationality"
                                  fullWidth
                                  error={!!formErrors[`nationality_${index}`]}
                                  helperText={
                                    formErrors[`nationality_${index}`]
                                  }
                                />
                              )}
                              onChange={(event, selectedOption) =>
                                handleNationalityChange(index, selectedOption)
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.name === value.name
                              }
                              value={
                                countryData.find(
                                  (country) => country.name === item.nationality
                                ) || null
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={1}>
                            <TextField
                              type="number"
                              value={item.price}
                              onChange={(e) =>
                                handleItemPriceChange(index, e.target.value)
                              } // Handle price change
                              size="small"
                              placeholder="Price"
                              fullWidth
                              error={!!formErrors[`price_${index}`]}
                              helperText={formErrors[`price_${index}`]}
                            />
                          </Grid>

                          <Grid item xs={12} md={1}>
                            <Box
                              display="flex"
                              justifyContent="flex-end"
                              alignItems="flex-end"
                              height="100%"
                            >
                              <Tooltip title="Remove Item">
                                <IconButton
                                  onClick={() => handleCloneItem(index)}
                                >
                                  <CopyAll />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Remove Item">
                                <IconButton
                                  onClick={() => handleDeleteItem(index)}
                                >
                                  <Delete />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  ))}
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleAddItem} // Add new item
                    startIcon={<Add />}
                  >
                    Add Item
                  </Button>
                </form>
                <Divider sx={{ my: 3 }} />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      options={userList}
                      getOptionLabel={(option) =>
                        `${option.LastName}  ${option.FirstName}`
                      }
                      sx={{ textTransform: "uppercase" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Sale Person"
                          size="small"
                          placeholder="Sale Person"
                          fullWidth
                        />
                      )}
                      // onChange={handleCustomerChange} // Update selected customer
                      onChange={(e) =>
                        setInvoiceDetails((prev) => ({
                          ...prev,
                          salesperson: e.target.value,
                        }))
                      }
                      isOptionEqualToValue={(option, value) =>
                        option._id === value._id
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Note"
                      size="small"
                      value={invoiceDetails.note}
                      onChange={(e) =>
                        setInvoiceDetails((prev) => ({
                          ...prev,
                          note: e.target.value,
                        }))
                      }
                    />
                  </Grid>

                  <Grid item xs={12} lg={4}>
                    <Card sx={{ p: 3 }}>
                      <Typography variant="h6">Invoice Summary</Typography>
                      <Divider sx={{ my: 2 }} />
                      <TableContainer>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell>Subtotal</TableCell>
                              <TableCell align="right">
                                {subtotal.toFixed(2)} AED
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Tax</TableCell>
                              <TableCell align="right">
                                {tax.toFixed(2)} AED
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Total</TableCell>
                              <TableCell align="right">
                                {total.toFixed(2)} AED
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
          {/* Actions Section */}
          <Grid item xs={12} lg={3}>
            {loadingImage ? (
              <span>Uploading image....</span>
            ) : (
              <Button
                variant="outlined"
                component="label"
                fullWidth
                style={{ marginTop: "16px", marginBottom: "16px" }}
              >
                Attach Document
                <input type="file" hidden onChange={handleFileChange} />
              </Button>
            )}

            <div>
              {/* {UploadedFile} */}
              <div align="center">
                {UploadedFile && (
                  <img
                    src={UploadedFile}
                    alt="Uploaded File"
                    style={{ width: "140px", height: "auto" }}
                  />
                )}
              </div>
            </div>
            <Card sx={{ p: 3 }}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                startIcon={<SendIcon />}
                sx={{ mb: 2 }}
                type="submit"
                // onClick={() => handleSubmit()}
              >
                Save Purchase
              </Button>
            </Card>
            <br />
            <br />
            <Typography>Select Payment Modes</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth style={{ marginTop: 15 }}>
                  <Select
                    multiple
                    value={selectedModes}
                    onChange={handleChange}
                    size="small"
                    renderValue={(selected) => selected.join(", ")} // Display selected values as comma-separated
                  >
                    {PaymentMode.map(({ mode }) => (
                      <MenuItem key={mode} value={mode}>
                        <Checkbox checked={selectedModes.indexOf(mode) > -1} />
                        <ListItemText
                          primary={mode}
                          style={{ textTransform: "capitalize" }}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {selectedModes.map((mode) => {
                // Find mode and corresponding options from PaymentMode
                const { options } =
                  PaymentMode.find((m) => m.mode === mode) || {};

                return (
                  <Grid container item xs={12} spacing={1} key={mode}>
                    <Grid
                      item
                      xs={4}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography
                        variant="body1"
                        style={{ textTransform: "capitalize" }}
                      >
                        {mode}:
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      {options && options.length > 0 && (
                        <FormControl fullWidth required>
                          <Autocomplete
                            options={options}
                            getOptionLabel={(subOption) =>
                              `${subOption.name} (Account: ${subOption.account})`
                            }
                            onChange={(event, newValue) => {
                              handleOptionChange(
                                mode,
                                newValue ? newValue._id : "",
                                newValue ? newValue.name : ""
                              );
                            }} // Update selected option
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Option"
                                size="small"
                                variant="outlined"
                                required
                              />
                            )}
                            value={
                              options.find(
                                (subOption) =>
                                  subOption._id === selectedOptions[mode]?._id
                              ) || null
                            }
                            isOptionEqualToValue={(option, value) =>
                              option._id === value._id
                            } // Comparison function by _id
                            fullWidth
                          />
                        </FormControl>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        type="number"
                        placeholder="Enter amount"
                        value={amounts[mode] || ""} // Controlled input for amount
                        onChange={(e) =>
                          handleAmountChange(mode, e.target.value)
                        } // Update amount
                        style={{ width: "100%" }} // Full width
                        required
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>

            <br />

            <br />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default InvoiceInterface;
